export default function RulebookTextKorean() {
  return <section id="rulebook-korean">
    <h1>윷놀이 하는 법 (How to Play Yutnori)</h1>

    <p>
      윷놀이는 윷이라고 불리는 네 개의 나무 막대로 하는 전통 한국 보드 게임입니다. 
      보통 설날 같은 명절에 많이 하지만, 언제든지 즐길 수 있습니다. 
      목표는 간단합니다: 상대 팀보다 먼저 모든 말을 말판을 한 바퀴 돌아 결승점에 도착시키는 것입니다.
    </p>

    <h2>필요한 것</h2>
    <ul>
      <li>윷 4개 (또는 온라인 버전을 이용하세요!)</li>
      <li>원형 경로가 있는 윷놀이 판</li>
      <li>2개 팀 (각 팀은 말 4개를 가짐)</li>
    </ul>

    <h2>윷 던지는 방법</h2>
    <p>4개의 윷을 던집니다. 떨어지는 방식에 따라 이동할 칸 수가 결정됩니다:</p>

    <table>
      <thead>
        <tr><th>윷 이름</th><th>이동 칸수</th><th>설명</th></tr>
      </thead>
      <tbody>
        <tr><td><strong>도</strong></td><td>1칸</td><td>한 개 뒤집힘 (평평한 면 하나)</td></tr>
        <tr><td><strong>개</strong></td><td>2칸</td><td>두 개 뒤집힘 (평평한 면 둘)</td></tr>
        <tr><td><strong>걸</strong></td><td>3칸</td><td>세 개 뒤집힘 (평평한 면 셋)</td></tr>
        <tr><td><strong>윷</strong></td><td>4칸</td><td>네 개 모두 평평 — 한번 더 던지기!</td></tr>
        <tr><td><strong>모</strong></td><td>5칸</td><td>네 개 모두 둥글게 — 한번 더 던지기!</td></tr>
        <tr><td><strong>뒷도</strong></td><td>-1칸</td><td>표시된 윷 하나만 평평 - 뒤로 이동</td></tr>
        <tr><td><strong>낙</strong></td><td>0칸</td><td>윷이 경기장 밖으로 나가면 이동 없음</td></tr>
      </tbody>
    </table>

    <p>
      윷이나 모를 던지면, 그 수만큼 이동하고 <em>한번 더</em> 던집니다. 
      그래서 큰 숫자가 연달아 나오면 게임이 뒤집힐 수 있습니다.
    </p>

    <h2>말 움직이기</h2>
    <p>
      말은 보드 주위의 경로를 따라 이동합니다. 
      모퉁이(행성)에는 지름길이 있습니다 — 모퉁이에 착륙하면 더 빠른 대각선 경로를 탈 수 있습니다.
    </p>

    <h3>업기 (말 쌓기)</h3>
    <p>자신의 말 두 개를 같은 칸에 착륙시켜 쌓을 수 있습니다. 쌓인 말은 하나처럼 함께 움직입니다.</p>

    <h3>잡기</h3>
    <p>상대방의 말 위에 착륙하면, 상대방의 말을 시작점으로 돌려보내고 한번 더 던집니다.</p>

    <h2>게임에서 이기는 방법</h2>
    <p>
      첫 번째로 <strong>모든 말을</strong> 보드를 한 바퀴 돌아 결승점에서 나가게 한 팀이 승리합니다.
    </p>

    <h2>간단한 턴 예시</h2>
    <ol>
      <li>윷을 던져서 <strong>걸 (3칸)</strong>이 나왔습니다.</li>
      <li>말 하나를 앞으로 3칸 이동시킵니다.</li>
      <li>상대방 말 위에 착륙하면 → 상대 말을 시작점으로 돌려보내고 한번 더 던집니다.</li>
      <li>윷이나 모가 나오면 → 자동으로 한번 더 던집니다.</li>
    </ol>

    <h2>초보자를 위한 팁</h2>
    <ul>
      <li>상대 말을 잡으세요 — 추가 턴이 매우 유리합니다.</li>
      <li>가능하면 대각선 지름길을 이용하세요.</li>
      <li>빠르게 이동하기 위해 말을 쌓으세요. 하지만 한꺼번에 둘 다 잡히지 않도록 주의하세요.</li>
      <li>말을 움직이기 전에 보너스 윷을 먼저 던지세요.</li>
      <li>첫 번째 칸에 있는 말은 뒷도가 나오면 바로 결승점으로 갈 수 있습니다.</li>
    </ul>

    <h2>온라인으로 플레이하기</h2>
    <p>
      3D 애니메이션 버전의 윷놀이를 온라인에서 즐기실 수 있습니다:
      <br/>
      <a href="https://www.yutnori.app">https://www.yutnori.app</a>
    </p>

    <h2>윷놀이의 역사와 문화</h2>
    <p>
      윷놀이는 수백 년 동안 한국에서 즐겨온 전통 놀이입니다. 
      가족과 친구들이 함께 모여 즐기는 대표적인 명절 놀이로, 
      단순한 규칙이지만 전략적인 요소가 많아 남녀노소 누구나 쉽게 배우고 즐길 수 있습니다.
      현대에는 온라인 게임으로도 제작되어 전 세계 사람들이 한국의 전통 문화를 경험할 수 있게 되었습니다.
    </p>

    <h2>관련 키워드</h2>
    <p>
      윷놀이, 윷놀이 하는법, 윷놀이 규칙, 전통 놀이, 한국 보드게임, 
      설날 놀이, 명절 놀이, 온라인 윷놀이, 윷놀이 게임, 
      윷 던지기, 도개걸윷모, 한국 전통 게임
    </p>

    <h2>자주 묻는 질문 (FAQ)</h2>
    
    <h3>윷놀이란 무엇인가요?</h3>
    <p>
      윷놀이는 윷이라고 불리는 네 개의 나무 막대로 하는 전통 한국 보드 게임입니다. 
      플레이어는 윷이 떨어지는 방식에 따라 말판 주위로 말을 이동시키며, 
      모든 말을 먼저 보드 밖으로 빼내는 것이 목표입니다.
    </p>

    <h3>윷놀이를 하려면 무엇이 필요한가요?</h3>
    <p>
      윷놀이를 하려면 네 개의 윷, 원형 경로가 있는 윷놀이 판, 그리고 두 팀의 말이 필요합니다. 
      yutnori.app에서 디지털 버전을 사용해 온라인으로 플레이할 수도 있습니다.
    </p>

    <h3>윷놀이 윷 던지기는 어떻게 작동하나요?</h3>
    <p>
      네 개의 윷을 던질 때마다 이동에 해당합니다: 도 (1칸), 개 (2칸), 걸 (3칸), 
      윷 (4칸과 추가 던지기), 모 (5칸과 추가 던지기), 뒷도 (표시된 윷으로 -1칸 뒤로 이동), 
      그리고 낙 (윷이 경계 밖으로 나가면 0칸, 이동 없음).
    </p>

    <h3>윷놀이에서 어떻게 이기나요?</h3>
    <p>
      상대 팀보다 먼저 모든 말을 보드를 한 바퀴 돌아 결승점에서 빼내면 윷놀이에서 승리합니다. 
      상대방 말을 잡고 지름길을 이용하는 것이 핵심 전략입니다.
    </p>

    <h3>윷놀이를 온라인으로 플레이할 수 있나요?</h3>
    <p>
      네. <a href="https://www.yutnori.app">https://www.yutnori.app</a>에서 
      내장된 규칙서가 있는 3D 애니메이션 온라인 버전의 윷놀이를 플레이할 수 있습니다.
    </p>
  </section>
}
